export default [
    {
        path: '/sales-order/change-invoice-address/:orderNr',
        name: 'sales_order_change_invoice_address',
        component: () => import('@src/sales-order/change-invoice-address.vue'),
        props(route: any) {
            return { ...route.params };
        },
        meta: {
            title: 'Rechnungsadresse ändern',
            role: 'ROLE_SALES_ORDER',
        },
    },
    {
        path: '/sales-order/bike-delay-mail-settings',
        name: 'sales_order_settings_bike_delay_mail',
        component: () => import('@src/sales-order/bike-delay-settings.vue'),
        meta: {
            title: 'Einstellungen verzögerter Bike-Bestellungen',
            role: 'ROLE_EDIT_SALES_ORDER_SETTINGS',
        },
    },
];
